//import { combineReducers } from 'redux-immutable';
import { handleActions, combineActions } from 'redux-actions';
import { Map } from 'immutable';

import actions from '../actions';

//REDUCERS
const availCalendarActions = actions.availCalendar;
export default handleActions(
  {
    [combineActions(availCalendarActions.getAsync.toString(), availCalendarActions.setRequested.toString())]: (
      avails,
      { payload }
    ) => {
      payload.forEach((avail, hotelId) => {
        avail.keySeq().forEach(queryString => {
          avails = avails
            .setIn([hotelId, queryString, 'raw_response'], avail.getIn([queryString, 'raw_response']))
            .setIn([hotelId, queryString, 'response'], avail.getIn([queryString, 'response']));
        });
      });
      return avails;
    },
  },
  Map()
);

//REDUCERS
//export default combineReducers({ hotel }, Record({ hotel: undefined }));
